// Entry point for the build script in package.json

/* eslint-disable no-undef */
import Rails from "@rails/ujs"
Rails.start()

import $ from "jquery"
import jQuery from "jquery"
window.$ = $
window.jQuery = jQuery

// Stimulus Controllers
import "./controllers"

// Other custom JavaScript files
import "./notification_button.js"
import "./bulma_collapsible.js"
import "./micromodal.js"
/* eslint-enable no-undef */
